module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_search.89c07b5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_search.svg
// module id = 3154
// module chunks = 0